import studyIndex from '@/views/study/studyIndex.vue'

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'studyIndex',
      name: 'studyIndex',
      component: studyIndex
    }

  ]
}
